import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { enumToStringArray, validateAllFormFields } from '../../../../../../const';
import { ActivatedRoute } from '@angular/router';
import { CompaniesEnum } from '../../../../../graphql/service/graphql-auto-main-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CheckProductionDatesParamsType } from '../../types/check-production-dates-params.type';

@Component({
  selector: 'app-check-production-dates-form',
  templateUrl: './check-production-dates-form.component.html',
  styleUrls: ['./check-production-dates-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckProductionDatesFormComponent implements OnInit, OnDestroy {
  @Output() formSubmitted = new EventEmitter<CheckProductionDatesParamsType>();
  companies = enumToStringArray(CompaniesEnum);
  form: FormGroup;

  private destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder, private route: ActivatedRoute) {
    this.form = this.fb.group({
      company: [null, Validators.required],
      vin: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.form.patchValue({
        company: params?.company,
        vin: params?.vin,
      });
    });
  }

  checkProductionDates(): void {
    validateAllFormFields(this.form);

    if (this.form.valid) {
      this.formSubmitted.emit(this.form.value);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
